module.exports = __webpack_public_path__ + "static/media/report_recording.c6205b09.svg";